import UserProfile from 'pages/BackOfficePage/BackOfficeCategories/UserProfile/UserProfile';

export default UserProfile;
